import { Utils } from '../../../../providers/utils';
import { LocalShoppingItemsData } from '../../providers/local-shopping-items-data';
import { ShoppingItemsDataGateway } from '../../providers/shopping-items-data-gateway';
import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { ShoppingListCommon } from './shopping-list.common';
import { PageBaseFull } from '../../../../core/page-base.full';
import { UserData } from '../../../../providers/user-data';
import { AppSettings } from '../../../../config/app-settings';
import { PageRef } from '../../../../core/core.module';
import firebase from 'firebase';
import { Helpers } from '../../../../providers/helpers';


@Component({
	selector: 'page-shopping-list-full',
	templateUrl: 'shopping-list.full.html'
})

export class ShoppingListPageFull extends PageBaseFull {
	public currentUser: any;
	public submitted = false;
	public formMsg: any;
	public realtimeDb: any;
	public shoppingList: any;
	public shopItems = [];
	userId = '';
	shoppingItemsData: any;
	loader: any;

	constructor(
		public events: Events,
		public app: App,
		public cd: ChangeDetectorRef,
		public common: ShoppingListCommon,
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public pageRef: PageRef,
		public shoppingItemsDataGateway: ShoppingItemsDataGateway,
		public localShoppingItemsData: LocalShoppingItemsData,
		public helpers: Helpers

	) {
		super(settings, events, nav, userData);
		this.realtimeDb = firebase.database();
	}

	ionViewDidEnter() {
		this.app.setTitle('Account > Shopping List');

	}

	ngAfterViewInit() {
		this.userId = this.currentUser ? this.currentUser.uid : '';
		this.shoppingItemsData = this.shoppingItemsDataGateway.getService(this.userId);
		this.loadData();
	}

	//UI Events
	public addToCart(itemKey) {
	}
	public cancel() {
		this.nav.setRoot(this.pageRef.get('home'));
	}
	public selectGotItem(item) {
		item.isGot = !item.isGot;
		this.shoppingItemsData.updateIsGotItem(this.userId, item, item.isGot);
	}
	removeListItemClick(item){
		var self = this;

		self.helpers.confirm(
			'',
			'Are you sure remove this item?',
			function(){
				self.removeListItem(item);
			}
		);
	}

	//Functions
	removeListItem(item){
		var self = this;
		self.shoppingItemsData.remove(self.userId, item.$key).then(result =>{
			if(result){
				self.loadData();
				self.helpers.toast("Removed successfully!");
			}
		})
	}
	loadData() {
		var self = this;
		self.helpers.showLoading();
		
		self.shoppingItemsData.get(this.userId).subscribe(shopitems => {
			shopitems = Utils.toAngularFireArray(shopitems).reverse();
			var shopItemData = [];
			_.forEach(shopitems, function (item) {
				if (item.$key != 'timestampCreated') {
					var shopItem = item;
					// shopItem.itemId = item.$key;
					shopItemData.push(shopItem);
				}
			});
			shopItemData = _.sortBy(shopItemData, function (item) {
				return item.categoryName;
			});
			var catQuanity = {};
			_.groupBy(shopItemData, function (item) {
				var catName = item.categoryName;
				catQuanity[catName] = catQuanity[catName] ? catQuanity[catName] + item.quantity : item.quantity;
				return catName;
			});
			var catTemp = '';
			// var itemCount = 0;
			_.forEach(shopItemData, function (item) {
				item.catQuantity = catQuanity[item.categoryName];

				if (catTemp != '' && item.categoryName == catTemp) {
					item.categoryName = '';//don't display catName while render shopping list ;
				}
				else {
					catTemp = item.categoryName;
				}

			});
			self.shopItems = shopItemData;

			self.helpers.hideLoading();
		});
	}
}


// WEBPACK FOOTER //
// ./src/modules/account/pages/shopping-list/shopping-list.full.ts